export const METHOD_OPTIONS = [
  {
    value: 'displacement',
    text: 'Displacement',
  },
  {
    value: 'caliper',
    text: 'Caliper',
  },
];

export const THEME_COLOR = '#336c40';

export const FORM_INPUTS = {
  displacement: {
    sampleWeight: {
      label: 'Sample weight (g)',
      placeholder: 'Grams',
      required: true,
      value: '',
    },
    initialWaterLevel: {
      label: 'Initial water level (ml)',
      placeholder: 'ml',
      required: true,
      value: '',
    },
    submergedWaterLevel: {
      label: 'Submerged water level (ml)',
      placeholder: 'ml',
      required: true,
      value: '',
    },
  },
  caliper: {
    sampleWeight: {
      label: 'Sample weight (g)',
      placeholder: 'Grams',
      required: true,
      value: '',
    },
    length: {
      label: 'Length (in)',
      placeholder: 'Inches',
      required: true,
      value: '',
    },
    width: {
      label: 'Width (in)',
      placeholder: 'Inches',
      required: true,
      value: '',
    },
    height: {
      label: 'Height (in)',
      placeholder: 'Inches',
      required: true,
      value: '',
    },
  },
};

export const INITIAL_RESULTS = {
  displacement: {
    initialLevel: {
      label: 'Initial level',
      colspan: 1,
      secondRow: {
        ml: 'ml',
      },
      units: {
        ml: 'ml',
      },
      values: {
        ml: '-',
      },
    },
    submergedLevel: {
      label: 'Submerged level',
      colspan: 1,
      secondRow: {
        ml: 'ml',
      },
      units: {
        ml: 'ml',
      },
      values: {
        ml: '-',
      },
    },
    volume: {
      label: 'Volume',
      colspan: 1,
      secondRow: {
        ml: 'ml',
      },
      units: {
        ml: 'ml',
      },
      values: {
        ml: '-',
      },
    },
    weight: {
      label: 'Weight',
      colspan: 1,
      secondRow: {
        grams: 'Grams',
      },
      units: {
        grams: 'g',
      },
      values: {
        grams: '-',
      },
    },
    density: {
      label: 'Density',
      colspan: 2,
      secondRow: {
        pfc: 'PFC',
        kgm3: '(Kg/m³)',
      },
      units: {
        pfc: 'PFC',
        kgm3: '(Kg/m³)',
      },
      values: {
        pfc: '-',
        kgm3: '-',
      },
    },
  },
  caliper: {
    foamCubeVolume: {
      label: 'Foam cube volume (inches)',
      colspan: 3,
      secondRow: {
        width: 'Width',
        height: 'Height',
        depth: 'Depth',
      },
      units: {
        width: 'in',
        height: 'in',
        depth: 'in',
      },
      values: {
        width: '-',
        height: '-',
        depth: '-',
      },
    },
    weight: {
      label: 'Weight',
      colspan: 1,
      secondRow: {
        grams: 'Grams',
      },
      units: {
        grams: 'g',
      },
      values: {
        grams: '-',
      },
    },
    density: {
      label: 'Density',
      colspan: 2,
      secondRow: {
        pfc: 'PFC',
        kgm3: '(Kg/m³)',
      },
      units: {
        pfc: 'PFC',
        kgm3: '(Kg/m³)',
      },
      values: {
        pfc: '-',
        kgm3: '-',
      },
    },
  },
};

export const TITLE = {
  displacement: 'Displacement Method',
  caliper: 'Caliper Method',
};

export const CALIPER_SECTIONS = [
  {
    title: 'What you need',
    images: [
      {
        file:
          'https://res.cloudinary.com/ocimages/image/upload/v1/pagebuilder/uploads/123/89fdacfd-1804-4a11-a33b-b830d029cc84/Icon_Caliper_Measure_RGB_1',
        image: {
          file:
            'https://res.cloudinary.com/ocimages/image/upload/v1/pagebuilder/uploads/123/b4988862-b4e1-4f8c-b5d6-41527bc02938/Icon_Caliper_Measure_RGB_1',
        },
        caption: 'Digital Calipers',
      },
      {
        image: {
          file:
            'https://res.cloudinary.com/ocimages/image/upload/v1/pagebuilder/uploads/123/56e52d84-b94c-4bf2-b2ad-a2ea84fe7d42/Icon_Measuring_Scale_RGB_1',
        },
        caption: 'Gram Scale',
      },
    ],
    content: {
      ops: [
        {
          insert: '\n',
        },
      ],
    },
    position: 'below',
  },
  {
    title: 'Instructions',
    images: [
      {
        image: {
          file:
            'https://res.cloudinary.com/ocimages/image/upload/v1/pagebuilder/uploads/123/9516230b-7d7c-4385-a86f-af5b8fc2508c/Group_1',
        },
      },
    ],
    content: {
      ops: [
        {
          insert:
            // eslint-disable-next-line max-len
            'Prepare approximately a 2" cube sample with no skins or knit lines. It is important that the sample has square corners with even sides, as close to a cube as possible. ',
        },
        {
          insert: {
            breaker: true,
          },
        },
        {
          insert: '\n',
          attributes: {
            list: 'ordered',
          },
        },
        {
          insert: 'Weigh the sample and enter the value.',
        },
        {
          insert: {
            breaker: true,
          },
        },
        {
          insert: '\n',
          attributes: {
            list: 'ordered',
          },
        },
        {
          insert: 'Measure length width and height in inches, enter values.',
        },
        {
          insert: '\n',
          attributes: {
            list: 'ordered',
          },
        },
      ],
    },
    position: 'below',
  },
];

export const DISPLACEMENT_SECTIONS = [
  {
    title: 'What you need',
    images: [
      {
        image: {
          file:
            'https://res.cloudinary.com/ocimages/image/upload/v1/pagebuilder/uploads/123/b4988862-b4e1-4f8c-b5d6-41527bc02938/Icon_Caliper_Measure_RGB_1',
        },
        caption: '1000 ml graduated cylinder',
      },
      {
        image: {
          file:
            'https://res.cloudinary.com/ocimages/image/upload/v1/pagebuilder/uploads/123/56e52d84-b94c-4bf2-b2ad-a2ea84fe7d42/Icon_Measuring_Scale_RGB_1',
        },
        caption: 'Gram Scale',
      },
      {
        image: {
          file:
            'https://res.cloudinary.com/ocimages/image/upload/v1/pagebuilder/uploads/123/c5ed769b-707d-4a70-ae29-78639922c228/Icon_Utility_Knife_RGB_1',
        },
        caption: 'Sharp knife to prepare a sample',
      },
    ],
    content: {
      ops: [
        {
          insert: '\n',
        },
      ],
    },
    position: 'below',
  },
  {
    title: 'Colect a sample',
    images: [],
    content: {
      ops: [
        {
          insert: 'Sample should weigh 5.5 - 10.0g',
        },
        {
          insert: {
            breaker: true,
          },
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet',
          },
        },
        {
          insert: 'Trim to easily fit the graduated cylinder',
        },
        {
          insert: {
            breaker: true,
          },
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet',
          },
        },
        {
          insert: 'Should not have any internal or external “skins” or knit lines',
        },
        {
          insert: '\n',
          attributes: {
            list: 'bullet',
          },
        },
      ],
    },
  },
  {
    title: 'Instructions',
    images: [],
    content: {
      ops: [
        {
          insert: 'Prepare a 5.5-10 gram sample with no skins. It should fit easily within the graduated cylinder',
        },
        {
          insert: {
            breaker: true,
          },
        },
        {
          insert: '\n',
          attributes: {
            list: 'ordered',
          },
        },
        {
          insert: 'Weigh the sample and enter the value.',
        },
        {
          insert: {
            breaker: true,
          },
        },
        {
          insert: '\n',
          attributes: {
            list: 'ordered',
          },
        },
        {
          insert: 'Fill the cylinder 2/3 with water and enter the initial water level. ',
        },
        {
          insert: {
            breaker: true,
          },
        },
        {
          insert: '\n',
          attributes: {
            list: 'ordered',
          },
        },
        {
          insert: 'Completely submerge the sample under the water level and enter the submerged value.',
        },
        {
          insert: '\n',
          attributes: {
            list: 'ordered',
          },
        },
      ],
    },
  },
];

export const DEFAULT_HEADER = {
  crop: {
    x: 0,
    y: 0,
    width: 1438,
    height: 900,
  },
  ctas: [],
  banner: {},
  heading: {
    ops: [
      {
        insert: 'Choose your calculation Method\n',
      },
    ],
  },
  prehead: '',
  bodyCopy: {
    ops: [
      {
        insert: 'The displacement method is only suitable for medium density (closed cell) products.',
      },
      {
        insert: {
          breaker: true,
        },
      },
      {
        insert: '\n',
        attributes: {
          list: 'bullet',
        },
      },
      {
        insert: 'The caliper method can be used for both closed and open cell ',
      },
      {
        insert: '\n',
        attributes: {
          list: 'bullet',
        },
      },
    ],
  },
};
